<template>
  <v-container class="h-100 pa-4 bg-black" fluid>
    <template v-for="(branch, branchName) in displayTeams" v-if="!noTeams" :key="branchName">
      <v-row justify="center">
        <v-col cols="12" class="text-h5 text-center mb-8 font-weight-medium">
          {{ branchName }}
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col v-for="(team, index) in branch" :key="index" cols="12" sm="6" md="3">
          <v-hover v-slot="{ isHovering, props }">
            <v-card v-bind="props" class="bg-black text-white" @click="showTeamModal(team)">
              <v-img
                height="200px"
                :src="team.image || missingLogo"
                cover
                aspect-ratio="16/9"></v-img>
              <v-card-title>{{ team.team_name }}</v-card-title>
              <v-card-subtitle>{{ team.team_level }}</v-card-subtitle>
              <v-card-actions>
                <a
                  v-if="team.facebook"
                  :href="`https://www.facebook.com/${team.facebook}`"
                  target="_blank"
                  ><v-icon icon="mdi-facebook"></v-icon
                ></a>
                <a v-if="team.twitter" :href="`https://www.x.com/${team.twitter}`" target="_blank"
                  ><v-icon>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      shape-rendering="geometricPrecision"
                      text-rendering="geometricPrecision"
                      image-rendering="optimizeQuality"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      viewBox="0 0 512 462.799">
                      <path
                        fill-rule="nonzero"
                        d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z" /></svg></v-icon
                ></a>
                <a
                  v-if="team.instagram"
                  :href="`https://www.instagram.com/${team.instagram}`"
                  target="_blank"
                  ><v-icon icon="mdi-instagram"></v-icon
                ></a>
                <a
                  v-if="team.youtube"
                  :href="`https://www.youtube.com/@${team.youtube}`"
                  target="_blank"
                  ><v-icon icon="mdi-youtube"></v-icon
                ></a>
                <a v-if="team.vimeo" :href="`https://www.vimeo.com/${team.vimeo}`" target="_blank"
                  ><v-icon icon="mdi-vimeo"></v-icon
                ></a>
                <a v-if="team.website" :href="`${team.website}`" target="_blank"
                  ><v-icon icon="mdi-web"></v-icon
                ></a>
              </v-card-actions>
              <!--  <v-overlay :model-value="!!isHovering" class="align-center justify-center" contained>
                <TeamViewComponent :team="team"></TeamViewComponent>
              </v-overlay>-->
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </template>
    <div v-else>No Teams have signed up yet.</div>
    <v-dialog v-model="showTeamInfo" scrollable max-width="800px">
      <v-container style="max-height: 70vh; overflow-y: auto">
        <v-sheet class="border-opacity-25 border-thin rounded-lg pa-5">
          <v-row v-if="selectedTeam?.bio">
            <v-col>
              <h1>{{ selectedTeam.team_name }}</h1>
              <h2>Team Bio:</h2>
              <div v-html="selectedTeam?.bio"></div>
            </v-col>
          </v-row>
          <v-row v-if="selectedTeam?.criteriaName">
            <v-col cols="12">
              <v-divider></v-divider>
              <h2>Selected Criteria:</h2>
            </v-col>
          </v-row>
          <v-row v-if="selectedTeam?.criteriaName">
            <v-col cols="12" md="6">
              <div>
                <h3>{{ selectedTeam?.criteriaGroupName }} - {{ selectedTeam?.criteriaName }}</h3>
              </div>

              <div v-html="selectedTeam?.criteriaDescription"></div>
            </v-col>
            <v-col cols="12" md="6">
              <v-img :src="selectedTeam?.criteriaAssetUrl">
                <template #sources>
                  <source :srcset="selectedTeam?.criteriaAssetWebPUrl" />
                </template>
              </v-img>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <FullWidthButton @click="showTeamInfo = false">Close</FullWidthButton>
            </v-col>
          </v-row>
        </v-sheet>
      </v-container>
    </v-dialog>
  </v-container>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { getTeamDisplayData } from '../../controllers';
import { ITeamDisplayDTO } from '../../dtos';
import missingLogo from '@/assets/missingteam.png';
//import TeamViewComponent from '@/components/TeamViewComponent.vue';

const route = useRoute();
const showTeamInfo = ref<boolean>(false);
const selectedTeam = ref<ITeamDisplayDTO | undefined>(undefined);
const year = computed(() => {
  if (route && route.query) {
    return Array.isArray(route.query.year)
      ? route.query.year[0]?.toString() || ''
      : route.query.year?.toString() || '';
  }
  return '';
});

const noTeams = computed(() => {
  if (displayTeams.value != undefined && Object.keys(displayTeams.value).length > 0) {
    return false;
  }
  return true;
});
const displayTeams = ref<{ [key: string]: ITeamDisplayDTO[] | undefined }>();

const fetchTeams = async () => {
  const objs = await getTeamDisplayData(year.value);
  const groupedByBranch = objs.reduce<{ [key: string]: ITeamDisplayDTO[] }>((acc, team) => {
    if (!acc[team.branch]) {
      acc[team.branch] = [];
    }
    acc[team.branch].sort((a, b) => a.team_name.localeCompare(b.team_name));
    acc[team.branch].push(team);
    return acc;
  }, {});
  displayTeams.value = groupedByBranch;
};

const showTeamModal = (team: ITeamDisplayDTO) => {
  selectedTeam.value = team;
  showTeamInfo.value = true;
};
onMounted(async () => {
  await fetchTeams();
});
</script>
